import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';
import {
  IassignCategoriesAPIResponse,
  IcreatePointOfSaleAPIBody,
  IcreatePointOfSaleAPIResponse,
  IgetPointOfSaleAPIResponse,
  IupdatePointOfSaleAPIBody,
  IupdatePointOfSaleAPIResponse,
  TremovePointOfSaleAPIResponse,
} from 'api/endpoints/pointsOfSale/pointsOfSale.response.interface';

export const getPointsOfSaleAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<IgetPointOfSaleAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_points_of_sale`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const createPointsOfSaleAPI = async ({
  body,
  token,
}: {
  body: IcreatePointOfSaleAPIBody;
  token: string;
}): Promise<IcreatePointOfSaleAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/create_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

export const updatePointOfSaleAPI = async ({
  body,
  token,
}: {
  body: IupdatePointOfSaleAPIBody;
  token: string;
}): Promise<IupdatePointOfSaleAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/update_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

export const removePointOfSaleAPI = async ({
  pointOfSaleId,
  token,
}: {
  pointOfSaleId: string;
  token: string;
}): Promise<TremovePointOfSaleAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/point_of_sale_profile/delete_point_of_sale`, {
      point_of_sale_id: pointOfSaleId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const assignCategoriesAPI = async ({
  pointOfSaleId,
  categories,
  token,
}: {
  pointOfSaleId: string;
  categories: string[];
  token: string;
}): Promise<IassignCategoriesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      point_of_sale_id: pointOfSaleId,
      category_ids: categories,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/assign_category`,
    params
  );
  return await safeJsonParse(response);
};
